import React, {  useRef, useState } from "react";
import Slider from "react-slick";
import { AnnouncementsIcon, NewBackArrowIconEventPage, NewNextArrowIconEventPage } from "../../utils/icons";
import { useHistory } from 'react-router-dom';
import SkeletonLoder from "../common/skeletonLoder";
import LazyImage from "../common/LazyImage/LazyImage";
// Assuming these are in your styles file, you may need to add/update them
import { 
  Layout, Container, SliderContainer, 
  ReservedButton, OuterCardContainer, 
  CompanyCard
} from "../UserDashboard/styles";
import { ImageUrl } from "../../utils/constants";
import PropTypes from "prop-types";
import parse from "react-html-parser";
import { InitiativeGraph } from "./styles";




const InitiativeSlider = ({
  title = "Recurring",
 
  data = [],
  showArrows = true,
  cardRender,
  showDots = true,
  loading = false, 
  icon = <AnnouncementsIcon/>
}) => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(1);
  const history = useHistory();

  const handleBeforeChange = (_, newIndex) => {
    setCurrentSlide(newIndex + 1);
  };

  
  window.console.log("data",data)


  const redirectionToDetailsPage = (data) => {

    if(data?.card_type === "fitness_video" ) 
    {
      history.push(`/education/videos-library/${data?.id}`)
    }
    else if(data?.card_type === "recipe" ) 
    {
      history.push(`/wellness-resources/recipe-details/${data?.id}`)
    }
    else if(data?.card_type === "article") 
    {
      history.push(`/wellness-resources/article-details/${data?.id}`)
    }
  }



  const sliderSettings = {
    dots: showDots,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
    adaptiveHeight: false,
    variableWidth: false,
    beforeChange: handleBeforeChange,
    responsive: [
      {
        breakpoint: 1252,
        settings: { dots: showDots, infinite: false, slidesToShow: 1, arrows: true },
      },
      {
        breakpoint: 600,
        settings: { dots: showDots, infinite: false, slidesToShow: 1, arrows: true },
      },
    ],
  };


  if (loading) return <SkeletonLoder width={"1248px"} height={"450px"} />;

  return (
    <OuterCardContainer isOuterpadding={data.length > 1 ? "0px 20px 46px 20px" : "0px 20px 20px 20px"}>
      <Layout margin="20px 0 0 0" padding="0px">
        <div className="headingMain">
          <div style={{ gap: "12px" }} className="heading">
            {icon}
            {title}
          </div>

          { showArrows && data.length > 1 && (
            <div className="arrows">
              {currentSlide > 1 ? (
                <div className="iconBackground" onClick={() => sliderRef.current?.slickPrev()}>
                  {NewBackArrowIconEventPage("#DA6C74")}
                </div>
              ):null}
              <div className="text">
                {currentSlide}/{data.length}
              </div>
              {currentSlide < data.length ? (
                <div className="iconBackground" onClick={() => sliderRef.current?.slickNext()}>
                  {NewNextArrowIconEventPage("#DA6C74")}
                </div>
              ):<div className="iconPlaceholder"></div>}
            </div>
          )}
        </div>

        <Container style={{border: "none",borderRadius:"8px",marginTop:"16px",height:"344px"}}>

          <SliderContainer display="flex" content="center" marginValue="0">
            <Slider {...sliderSettings} ref={sliderRef}>


              {data.map((item, index) =>
                cardRender ? (
                  cardRender(item, index) 
                ) : (
                  <div className="card" key={index}>
                    <CompanyCard detailsCardPadding="20px" 
                      isCursorPointer={"default"}
                      onClick={() => redirectionToDetailsPage(item) }>
                      <LazyImage className="imageCardUserDashboard" src={`${ImageUrl}/${item?.initiative_image}`} alt="event" />
                     
                      <div className="detailsCard">
                        <div className="title">{item?.title }</div>
                      
                        <div className="details">{parse(item?.about)}</div>

                        <InitiativeGraph>
                          <div style={{ position: "relative", width: "70px", height: "70px" }}>
                            <svg width="70" height="70" viewBox="0 0 100 100">
                              <circle cx="50" cy="50" r="40" stroke="#EFEFEF" strokeWidth="10" fill="transparent" />
                              <circle cx="50" cy="50" r="40" stroke="#4CAF50" strokeWidth="10" fill="transparent" 
                                strokeDasharray="251.2" strokeDashoffset={251.2 - (251.2 * item.progress) / 100} 
                                strokeLinecap="round" />
                              <text x="50" y="55" textAnchor="middle" fontSize="20" fontWeight="700" fill="#092F41">{item.progress}%</text>
                            </svg>
                          </div>
  
                          <div style={{ fontSize: "16px", color: "#184A61" }}>
                            <div className="heading">Users Completed :<span className="sub-heading">{item.total_participation} </span></div>
                            <div className="heading">Users Invited : <span  className="sub-heading">{item.user_count} </span></div>
                            <div className="heading">Ends in : <span  className="sub-heading">{item.ends_in} Days </span></div>
                          </div>
                        </InitiativeGraph>
                       

                      

                        <div style={{ display: "flex", gap: "12px", marginTop: "auto" }}>
                          <ReservedButton 
                            style={{ flex: 1, height: "40px" }}
                            onClick={() => history.push(`/initiative-details/${item.id}`)}
                          >
                            View Details
                          </ReservedButton>
                          <ReservedButton 
                            // active={1} 
                            style={{ flex: 1, height: "40px" }}
                            onClick={() => window.console.log("Notify Users")}
                          >
                            Send Notification
                          </ReservedButton>
                        </div>
                       
                      </div>
                    </CompanyCard>
                  
                  </div>
                )
              )}
            </Slider>
          </SliderContainer>
        </Container>
      </Layout>
    </OuterCardContainer>
  );
};


InitiativeSlider.propTypes =
{
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  cardRender: PropTypes.func,
  showArrows: PropTypes.bool,
  showDots: PropTypes.bool,
  myAnnouncementCard: PropTypes.bool,
  myActicityCard: PropTypes.bool,
  myFocusCard: PropTypes.bool,
  refreshAnnouncements: PropTypes.func,
  activeFocusKey: PropTypes.string,
  loading: PropTypes.bool,
  icon: PropTypes.node,  
  CatgoryName:PropTypes.string,
  CategoryType:PropTypes.string,
}

export default InitiativeSlider;